import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing the FilterBalanceHistoryView.
 * @extends JetView
 */
export default class FilterBalanceHistoryView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for User ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Permission check for filtering by user
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for date selection
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Permission check for filtering by country
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'combo', // Combo box for sorting options
                            name: 'Sort',
                            label: _('Ordenar por'), // Localized label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '1', value: _('Calc. Desfase') },
                                { id: '2', value: _('GGR. Deportivas') },
                                { id: '3', value: _('GGR. Casino') },
                                { id: '4', value: _('Fecha de Creación') },
                            ],
                            value: '1', // Default sorting option
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'combo', // Combo box for order direction
                            name: 'Dir',
                            label: _('Orden'), // Localized label
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0', // Default order direction
                        },
                        {
                            view: 'radio', // Radio buttons for type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Localized label
                            labelPosition: 'top',
                            minWidth: 200,
                            height:
                                screen.width < 500 || screen.height < 500
                                    ? 90 // Adjust height for small screens
                                    : 0,
                            value: 1, // Default type
                            options: [
                                { id: 1, value: _('Totales') },
                                { id: 0, value: _('Detallado') },
                            ],
                        },
                        { id: 'grav2', gravity: 2, minWidth: 200 }, // Gravity for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear form
                    value: _('Limpiar'), // Localized label
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit form
                    value: _('Consultar'), // Localized label
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear second form
                    value: _('Limpiar'), // Localized label
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button to submit second form
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion on larger screens
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if not applicable
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
